import Button from '@mui/material/Button';

export async function calculate(answers) {
    const { primarycolor } = answers;
    let message = "";

  if (answers.switchedElectricityPlan === 'Y') {
    message = (
        <span>
          You have switched electricity plans recently and a basic estimation will not be accurate.<br/><br/>To get a precise, personalised quote and see your best options, use our interactive comparison tool now.
          <br/><br/>
          <Button
            variant="contained"
            onClick={() => window.location.href = "https://energyefficiency.ie/utilities/gas-electricity-calculator/"}
            style={{
              marginTop: '10px',
              backgroundColor: primarycolor,
              borderColor: primarycolor
            }}
          >
            Switching Calculator
          </Button>
        </span>
      );

    return {
      status: "Assessment Required",
      items: [],
      message: message,
      color: "orange",
      title: "Estimated Annual Savings"
    };
  }
  console.log("Electricity savings calculation started with answers:", answers);
  
  // Mapping config values to proper provider names used in the CSV
  const providerMapping = {
    "bord_gais": "Bord Gais",
    "community_power": "Community Power",
    "ecopower": "Ecopower",
    "electric_ireland": "Electric Ireland",
    "energia": "Energia",
    "flogas": "Flogas",
    "pinergy": "Pinergy",
    "prepay_power": "Prepay Power",
    "sse_airtricity": "SSE Airtricity",
    "waterpower": "Waterpower",
    "yuno": "Yuno Energy"
  };

  // Mapping tariff type to match CSV case formats
  const tariffMapping = {
    "24hr": "24hr",
    "nightsaver": "Nightsaver",
    "smart": "Smart"
  };

  const providerName = providerMapping[answers.electricityProvider];
  if (!providerName) {
    return {
      status: "Select Your Provider",
      items: [],
      message: "Please select your current electricity provider to see how much you could save.",
      color: "grey",
      title: "Estimated Annual Savings"
    };
  }

  const tariffName = tariffMapping[answers.tariffType];
  if (!tariffName) {
    return {
      status: "Error",
      items: [],
      message: "Invalid tariff type.",
      color: "red",
      title: "Error"
    };
  }

  // Mapping table based on the Data CSV
  const planMapping = {
    "Bord Gais": {
      "24hr": "d366db79-6340-432c-b184-eaa358e02fbd",
      "Nightsaver": "6bc41553-569e-4bb4-8874-ef61b25a9bcd",
      "Smart": "c1e2c766-c613-41c3-8e22-774b40132d72"
    },
    "Community Power": {
      "24hr": "1110c6f0-7e68-4877-8d7e-be0f27b5d621",
      "Nightsaver": "6e53bff1-28ac-4722-a6f9-6f953794b876",
      "Smart": "4b61df68-0c05-4973-b037-af4ae86ba489"
    },
    "Ecopower": {
      "24hr": "ba78484a-9df0-4125-9c41-bd0282204e14",
      "Nightsaver": "9f036197-0d44-4011-8a9c-e754ee2af4b4",
      "Smart": "0491c1c8-4f4d-4b86-a4be-0f56f5b434bf"
    },
    "Electric Ireland": {
      "24hr": "75c72d56-4848-4406-96a2-ab88bb20a596",
      "Nightsaver": "e63a38b7-4e3c-432e-9749-e197fd22a90a",
      "Smart": "42c4d02a-c8e6-4ee2-a102-3ba5d09204a7"
    },
    "Energia": {
      "24hr": "26f17282-0d4b-4d6f-a855-39e37c4d946b",
      "Nightsaver": "853e6ef0-34ef-4fe8-b01a-12a857521429",
      "Smart": "e5581984-f474-42f2-9252-b87082887282"
    },
    "Flogas": {
      "24hr": "014c7094-45e8-4e98-b85b-d5c2cc6fef0b",
      "Nightsaver": "517650f6-2c06-40b4-823e-6d1342a1a4ba",
      "Smart": "8a56f14c-bcc7-481a-96b2-52c6defd7172"
    },
    "Pinergy": {
      "24hr": "a1bd0825-dc87-4db7-bae5-254e7d9d05db",
      "Nightsaver": "8a10d550-a34a-4fb9-a06b-6643655c2bbf",
      "Smart": "624aa2d6-7e9a-4026-ac8f-87c64a857f87"
    },
    "Prepay Power": {
      "24hr": "e8ea524e-c406-4693-965c-18eb8d77de74",
      "Nightsaver": "efd2f89f-6885-4958-9ea3-1440f78d45af",
      "Smart": "22b29c3c-db2e-496c-81d7-ef9a50dc4cdc"
    },
    "SSE Airtricity": {
      "24hr": "989a5f39-b3e5-4785-ab30-6a7f2fb7ac33",
      "Nightsaver": "2c546769-57f6-470e-88f0-d161d5b8efe2",
      "Smart": "ae3e39d1-4dd7-48f6-bd95-ae6bc3b117d5"
    },
    "Waterpower": {
      "24hr": "69927c36-bd2b-494e-b2d4-1b85903838b3",
      "Nightsaver": "efd578f7-2c75-4625-ac72-a7ecb9d176f1",
      "Smart": "56c50b54-1146-46e8-a6d1-49a94e1304bd"
    },
    "Yuno Energy": {
      "24hr": "09954834-474e-45d0-929f-6d1e61b460ed",
      "Nightsaver": "6efdd7a8-8aaf-48ce-9072-3fc733b5dc16",
      "Smart": "8d1cec44-9dd9-4122-9c36-b94d280368d0"
    }
  };

  const planData = planMapping[providerName];
  if (!planData) {
    return {
      status: "Error",
      items: [],
      message: "Plan mapping not found for provider.",
      color: "red",
      title: "Error"
    };
  }

  const planId = planData[tariffName];
  if (!planId) {
    return {
      status: "Error",
      items: [],
      message: "Plan ID not found for selected tariff.",
      color: "red",
      title: "Error"
    };
  }

  // Construct API URL (placeholder endpoint)
  const apiUrl = `https://of9o52h4hl.execute-api.eu-west-1.amazonaws.com/prod/comparison-new/max-savings`;
  
  // Prepare payload to send to the API
const payload = {
    planId,
    includeSmartPlans: answers.tariffType === 'smart' ? "Yes" : answers.includeSmartPlans
};
  
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }
    const apiResult = await response.json();

    console.log("Electricity savings data:", apiResult);
    const bestPlan = apiResult.bestPlan;

    // Mapping of supplier names to their image URLs (update with actual paths)
    const providerImageMapping = {
      "Bord Gais": "https://energyefficiency.ie/wp-content/uploads/2023/10/Bord_Gais_Energy.png",
      "Community Power": "https://energyefficiency.ie/wp-content/uploads/2023/10/Community-Power-electricity.png",
      "Ecopower": "https://energyefficiency.ie/wp-content/uploads/2023/10/Ecopower.png",
      "Electric Ireland": "https://energyefficiency.ie/wp-content/uploads/2024/10/electric-ireland.jpg",
      "Energia": "https://energyefficiency.ie/wp-content/uploads/2023/10/Energia_Logo.png",
      "Flogas": "https://energyefficiency.ie/wp-content/uploads/2023/10/flogas.png",
      "Pinergy": "https://energyefficiency.ie/wp-content/uploads/2023/10/pinergy.jpg",
      "Prepay Power": "https://energyefficiency.ie/wp-content/uploads/2023/10/PrepayPower.png",
      "SSE Airtricity": "https://energyefficiency.ie/wp-content/uploads/2023/10/SSE-Airtricity-logo.jpg",
      "Waterpower": "https://energyefficiency.ie/wp-content/uploads/2023/10/Waterpower.png",
      "Yuno Energy": "https://energyefficiency.ie/wp-content/uploads/2024/01/yuno-energy.jpg"
    };

    const supplierImage = bestPlan ? providerImageMapping[bestPlan.supplier_name] : '';

    let items = [];
    if (bestPlan) {
      // Compute predicted cost based on bestPlan's fields
      const dayRate = parseFloat(bestPlan["day_rate"]);
      const peakRate = parseFloat(bestPlan["peak_rate"]);
      const standingCharge = parseFloat(bestPlan["standing_charge_electricity"]);
      const predictedBestPlanCost = dayRate + peakRate + standingCharge;
      const predictedCurrentCost = predictedBestPlanCost + bestPlan.savings;
    message = (
      <span>
        <strong>Important:</strong> This is just an estimate — your real savings could be even better! To get a precise, personalised quote and see your best options, use our interactive comparison tool now. It’s fast, easy, and compares every plan in the market.
        <br/><br/>
        <Button
          variant="contained"
        onClick={() => window.location.href = "https://energyefficiency.ie/utilities/gas-electricity-calculator/"}
          style={{
            marginTop: '10px',
            backgroundColor: primarycolor,
            borderColor: primarycolor
          }}
        >
          Compare All Plans
        </Button>
      </span>
    );
      
      // Existing "Predicted Best Switch" items
      items.push(<span><strong>Recommended Plan</strong></span>);
      // Single clickable product ad item
      items.push(
        <a href={"https://energyefficiency.ie/utilities/gas-electricity-calculator/"} style={{textDecoration: 'none'}} className="bq-product-ad">
          <div style={{
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "15px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}>
            <img src={supplierImage} className="bq-widget-img" style={{marginBottom: "10px"}}/>
            <span style={{fontWeight: "bold", marginBottom: "5px", color: "black"}}>{bestPlan["tariff_name"]}</span>
            <span style={{color: "black"}}>12 months contract</span>
            <span style={{marginTop: "10px", color: "blue", textDecoration: "underline", fontSize: "0.9rem"}}>
              Click for details
            </span>
          </div>
        </a>
      );
    }
    
    return {
      status: `€${Number(apiResult.maxSavings).toFixed(2)}`,
      message: message,
      items,
      color: "green",
      title: "Estimated Annual Savings"
    };
  } catch (error) {
    console.error("Error fetching electricity savings data:", error);
    return {
      status: "Error",
      items: [],
      message: "Failed to retrieve savings data.",
      color: "red",
      title: "Error"
    };
  }
}
